"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertTextHistoryItem = void 0;
var tslib_1 = require("tslib");
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var history_item_1 = require("../base/history-item");
var InsertTextHistoryItem = (function (_super) {
    tslib_1.__extends(InsertTextHistoryItem, _super);
    function InsertTextHistoryItem(modelManipulator, params) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.params = params.clone();
        return _this;
    }
    InsertTextHistoryItem.prototype.canBeMerged = function () {
        return true;
    };
    InsertTextHistoryItem.prototype.redo = function () {
        this.modelManipulator.text.insertTextInner(this.params);
    };
    InsertTextHistoryItem.prototype.undo = function () {
        this.modelManipulator.range.removeIntervalWithoutHistory(this.params.subDocPos.subDocument, new fixed_1.FixedInterval(this.params.subDocPos.position, this.params.text.length), false);
    };
    return InsertTextHistoryItem;
}(history_item_1.HistoryItem));
exports.InsertTextHistoryItem = InsertTextHistoryItem;
